import React from 'react'
import PropTypes from 'prop-types'

import { NOOP } from '@fedsim/helpers'
import { fontFamilies, BORDERRADIUS as borderRadius } from "@fedsim/constants"

import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles'

import { ImageBlock } from './image-block'

export const useOptionsStyles = makeStyles({
  // root: {
  //   width: '100%',
  //   margin: 0,
  //   padding: 0
  // },
  togglebuttongroup: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    borderRadius,
    overflow: 'hidden'
  },
  button: {
    flex: 1,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
    opacity: 0.6,
    '&:hover': {
      opacity: 0.9,
      letterSpacing: '0.5px'
    }
  },
  active: {
    opacity: 1
  }
})

export const AntToggleButton = styled(props => (
  <ToggleButton
    variant='filled'
    color='primary'
    {...props} />
))(() => ({
  fontFamily: fontFamilies.secondaryFont,
  borderRadius,
  marginRight: 0,
  maxWidth: '200px',
  minWidth: '100px',
  textTransform: 'none',
  '&.Mui-selected:hover, &:hover': {
    opacity: 1,
    fontWeight: 500
  }
}))

export const Options = ({
  onChange = NOOP,
  value = '',
  values = [],
  size = 'small',
  none = false,
  noneString = 'None',
  options = [],
}) => {
  const classes = useOptionsStyles()
  const changeHandler = (event, newValue) => onChange(newValue)
  if (options.length === 0 && !none) {
    return null
  }
  return (
    <>
      <ToggleButtonGroup
        value={String(value) || values}
        exclusive
        size={size}
        onChange={changeHandler}
        aria-label='selection'
        className={classes.togglebuttongroup}
      >
        {options.map(
          ({ name, active, image, Icon = false, inactive, id, style, ...option }) => {
            const isActive =
              value === option.value || values?.includes(option.value)
            const className = isActive ? classes.active : classes.inactive
            return (
              <AntToggleButton
                key={`${id}`}
                value={String(option.value) || ''}
                className={`${classes.button} ${className}`}
                style={style}
              >
                {Icon && <Icon />}
                {!image ? name : ''}
                {!image ? (
                  isActive ? (
                    active
                  ) : (
                    inactive
                  )
                ) : (
                  <ImageBlock image={image}>{name}</ImageBlock>
                )}
              </AntToggleButton>
            )
          }
        )}
        {none && (
          <ToggleButton value=''
            aria-label='none'
            className={classes.button}>
            {noneString}
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </>
  )
}

Options.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  values: PropTypes.array,
  none: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      value: PropTypes.any,
      active: PropTypes.any,
      inactive: PropTypes.any
    })
  )
}
